import { c as _c } from "react/compiler-runtime";
import { usePageFilters } from "@/components/providers/AppFilterProvider/AppFilterProvider";
import { partitionFilterValues } from "../../utils";
import { ValuesSchemaType } from "../../schemas";
export function useMobileFilterCategorySheet(pageKey, filterId, availableValues) {
  const $ = _c(22);
  const {
    filters,
    toggleValue,
    setOperator,
    clearFilter
  } = usePageFilters(pageKey);
  const filterState = filters[filterId];
  let t0;
  if ($[0] !== filterState?.values) {
    t0 = filterState?.values ?? [];
    $[0] = filterState?.values;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeValueIds = t0;
  const currentOperator = filterState?.operator ?? "";
  const hasActiveValues = activeValueIds.length > 0;
  let t1;
  if ($[2] !== activeValueIds || $[3] !== availableValues) {
    t1 = partitionFilterValues(availableValues, activeValueIds);
    $[2] = activeValueIds;
    $[3] = availableValues;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    activeValues,
    inactiveValues
  } = t1;
  let t2;
  if ($[5] !== filterId || $[6] !== toggleValue) {
    t2 = value => toggleValue(filterId, String(value));
    $[5] = filterId;
    $[6] = toggleValue;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleToggle = t2;
  let t3;
  if ($[8] !== filterId || $[9] !== setOperator) {
    t3 = operator => setOperator(filterId, operator);
    $[8] = filterId;
    $[9] = setOperator;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleSetOperator = t3;
  let t4;
  if ($[11] !== clearFilter || $[12] !== filterId) {
    t4 = () => clearFilter(filterId);
    $[11] = clearFilter;
    $[12] = filterId;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleClear = t4;
  let t5;
  if ($[14] !== activeValues || $[15] !== currentOperator || $[16] !== handleClear || $[17] !== handleSetOperator || $[18] !== handleToggle || $[19] !== hasActiveValues || $[20] !== inactiveValues) {
    t5 = {
      activeValues,
      inactiveValues,
      currentOperator,
      hasActiveValues,
      handleToggle,
      handleSetOperator,
      handleClear
    };
    $[14] = activeValues;
    $[15] = currentOperator;
    $[16] = handleClear;
    $[17] = handleSetOperator;
    $[18] = handleToggle;
    $[19] = hasActiveValues;
    $[20] = inactiveValues;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}